import { render, staticRenderFns } from "./bottom-copyright.vue?vue&type=template&id=d4cff400&scoped=true"
var script = {}
import style0 from "./bottom-copyright.vue?vue&type=style&index=0&id=d4cff400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cff400",
  null
  
)

export default component.exports